import { createContext, useContext } from 'react';

const readonlyContext = createContext(false);

export const useIsReadonly = () => useContext(readonlyContext);

export const ReadonlyProvider = readonlyContext.Provider;
